<template>
  <div class="info-fill-container">
    <div class="info-fill-page">
      <!-- 页面标题 -->
      <div class="page-header">
        <h2 class="h2">信息补充</h2>
        <span class="tag">
          <el-tag type="success">已登录</el-tag>
          请完善相关信息。
        </span>
      </div>

      <!-- 表单主体：严格一行两列布局 -->
      <el-form
        ref="infoForm"
        :model="formData"
        :rules="rules"
        label-width="120px"
        class="info-form"
      >
        <!-- 单位信息区域 -->
        <div class="form-section">
          <h3 class="section-title">【单位信息】</h3>
          <el-row :gutter="24" class="form-row">
            <!-- 左列 -->
            <el-col :span="12" class="form-col">
              <el-form-item label="单位名称" prop="unitName">
                <el-input
                  v-model="formData.unitName"
                  placeholder="请输入单位名称"
                />
              </el-form-item>
              <el-form-item label="所在地区" prop="adcode">
                <el-cascader
                    v-model="formData.adcode"
                    style="width: 100%"
                    :options="locationOptions"
                    clearable
                    :props="{ label: 'name', value: 'adcode', checkStrictly: true }"
                />
              </el-form-item>
              <el-form-item label="单位类型" prop="unitType">
                <el-select
                    v-model="formData.unitType"
                    placeholder="请选择单位类型"
                >
                  <el-option v-for="item in businessTypes" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="营业执照" prop="businessLicenseUrl">
                <contract-upload
                    :limit="1"
                    @file-change="handleLicenseUpload"
                />
              </el-form-item>
            </el-col>

            <!-- 右列 -->
            <el-col :span="12" class="form-col">
              <el-form-item label="法人类型" prop="legalType">
                <el-select
                  v-model="formData.legalType"
                  placeholder="请选择法人类型"
                >
                  <el-option label="自然人" value="natural" />
                  <el-option label="企业" value="enterprise" />
                </el-select>
              </el-form-item>
              <el-form-item label="单位地址" prop="unitAddr">
                <el-input
                    v-model="formData.unitAddr"
                    placeholder="请输入单位详细地址"
                />
              </el-form-item>
              <el-form-item label="执照期限" prop="licenseTerm">
                <el-select
                  v-model="formData.licenseTerm"
                  placeholder="请选择执照期限"
                >
                  <el-option label="长期" value="long-term" />
                  <el-option label="10年" value="10-years" />
                  <el-option label="5年" value="5-years" />
                  <el-option label="1年" value="1-years" />
                </el-select>
              </el-form-item>

              <el-form-item label="所属行业" prop="industry">
                <el-select
                  v-model="formData.industry"
                  placeholder="请选择所属行业"
                >
                  <el-option v-for="item in Industry" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 法人信息区域 -->
        <div class="form-section">
          <h3 class="section-title">【法人信息】</h3>
          <el-row :gutter="24" class="form-row">
            <!-- 左列 -->
            <el-col :span="12" class="form-col">
              <el-form-item label="法人姓名" prop="legalName">
                <el-input
                  v-model="formData.legalName"
                  placeholder="请输入法人姓名"
                />
              </el-form-item>
              <el-form-item label="手机号码" prop="legalPhone">
                <el-input
                  v-model="formData.legalPhone"
                  placeholder="请输入11位手机号码"
                />
              </el-form-item>
              <el-form-item label="电子邮箱" prop="legalEmail">
                <el-input
                  v-model="formData.legalEmail"
                  placeholder="请输入常用电子邮箱"
                />
              </el-form-item>
              <el-form-item class="addTitle" label="身份证照片" prop="idCardFrontUrl">
                <contract-upload
                    :limit="2"
                    :uploadText="idCardFileList.length>=1?'请上传身份证-国徽面':'请上传身份证-人像面'"
                    @file-change="handleIdCardUpload"
                />
              </el-form-item>
            </el-col>

            <!-- 右列 -->
            <el-col :span="12" class="form-col">
              <el-form-item label="身份证号" prop="legalIdCard">
                <el-input
                  v-model="formData.legalIdCard"
                  placeholder="请输入18位身份证号"
                />
              </el-form-item>
              <el-form-item label="身份证有效期" prop="idCardValidity">
                <el-input
                  v-model="formData.idCardValidity"
                  placeholder="例如：2025-01-01 至 长期"
                />
              </el-form-item>
              <el-form-item label="联系地址" prop="legalContactAddr">
                <el-input
                  v-model="formData.legalContactAddr"
                  placeholder="请输入详细联系地址"
                />
              </el-form-item>
              <el-form-item v-if="false" label="备用字段" class="empty-item">
                <div class="empty-placeholder"></div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 账户代表区域 -->
        <div class="form-section">
          <h3 class="section-title">【账户代表】</h3>
          <el-row :gutter="24" class="form-row">
            <!-- 左列 -->
            <el-col :span="12" class="form-col">
              <el-form-item label="姓名" prop="accountRepName">
                <el-input
                  v-model="formData.accountRepName"
                  placeholder="请输入账户代表姓名"
                />
              </el-form-item>
              <el-form-item label="身份证有效期" prop="repIdCardValidity">
                <el-input
                  v-model="formData.repIdCardValidity"
                  placeholder="例如：2025-01-01 至 长期"
                />
              </el-form-item>
            </el-col>

            <!-- 右列 -->
            <el-col :span="12" class="form-col">
              <el-form-item label="身份证号" prop="repIdCard">
                <el-input
                  v-model="formData.repIdCard"
                  placeholder="请输入18位身份证号"
                />
              </el-form-item>
              <el-form-item v-if="false"  label="备用字段" class="empty-item">
                <div class="empty-placeholder"></div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 企业简介区域 -->
        <div class="form-section">
          <h3 class="section-title">【企业简介】</h3>
          <el-form-item label="企业简介" prop="companyIntro">
            <el-input
                v-model="formData.companyIntro"
                type="textarea"
                placeholder="请简要介绍企业经营范围、规模等信息"
                rows="4"
            />
          </el-form-item>
        </div>

        <!-- 提交按钮 -->
        <el-form-item class="submit-btn">
          <el-button type="primary" @click="handleCancel" size="medium">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" size="medium">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import ContractUpload from '@/components/commonUpload/ContractUpload.vue'
import {getAreaTreeData} from "@/API/news/news";
export default {
  name: 'InfoFillForm',
  components:{
    ContractUpload
  },
  props: {
    initFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    // 身份证号校验规则
    const validateIdCard = (rule, value, callback) => {
      const idCardReg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!value) {
        callback(new Error('请输入身份证号'));
      } else if (!idCardReg.test(value)) {
        callback(new Error('请输入正确的18位身份证号'));
      } else {
        callback();
      }
    };

    // 手机号码校验规则
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的11位手机号码'));
      } else {
        callback();
      }
    };

    // 电子邮箱校验规则
    const validateEmail = (rule, value, callback) => {
      const emailReg = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback(new Error('请输入电子邮箱'));
      } else if (!emailReg.test(value)) {
        callback(new Error('请输入正确的电子邮箱格式'));
      } else {
        callback();
      }
    };

    // 身份证有效期校验规则
    const validateIdCardValidity = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证有效期'));
      } else if (
        !/^(\d{4}-\d{2}-\d{2})\s+至\s+(长期|\d{4}-\d{2}-\d{2})$/.test(value)
      ) {
        callback(new Error('请按格式输入（例如：2025-01-01 至 长期）'));
      } else {
        callback();
      }
    };

    // 姓名校验规则
    const validateName = (rule, value, callback) => {
      const nameReg = /^[\u4e00-\u9fa5]{2,8}$/;
      if (!value) {
        callback(new Error('请输入姓名'));
      } else if (!nameReg.test(value)) {
        callback(new Error('请输入2-8位中文姓名'));
      } else {
        callback();
      }
    };

    // 地址校验规则
    const validateAddress = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系地址'));
      } else if (value.length < 5) {
        callback(new Error('地址长度不能少于5个字符'));
      } else {
        callback();
      }
    };

    // 身份证照片上传校验
    const validateIdCardPhoto = (rule, value, callback) => {
      if (this.idCardFileList.length === 0) {
        callback(new Error('请上传身份证照片'));
      } else {
        callback();
      }
    };

    return {
      formData: {
        // 单位信息
        unitName: '',     // 单位名称
        unitAddr: '',     // 单位地址
        unitType: '',                     // 单位类型
        legalType: '',             // 法人类型，natural：自然人，enterprise：企业
        licenseTerm: '',                  // 营业执照期限
        adcode: '',                     // 所在省份
        industry: '',                     // 所属行业
        businessLicenseUrl: '',              // 营业执照图片
        // 法人信息
        legalName: '',                    // 法人姓名
        legalPhone: '',                   // 法人手机号码
        legalEmail: '',                   // 法人电子邮箱
        legalIdCard: '',                  // 法人身份证号
        idCardValidity: '',               // 身份证有效期
        legalContactAddr: '',             // 法人联系地址
        idCardFrontUrl: '',               // 身份证正面URL
        idCardBackUrl: '',                // 身份证国徽URL
        // 账户代表
        accountRepName: '',               // 账户代表姓名
        repIdCard: '',                    // 账户代表身份证号
        repIdCardValidity: '',            // 账户代表身份证有效期
        // 企业简介
        companyIntro: '',                 // 企业简介
      },
      // 完整表单校验规则
      rules: {
        // 法人信息校验
        legalName: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        legalPhone: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
        legalEmail: [
          { required: true, validator: validateEmail, trigger: 'blur' },
        ],
        legalIdCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' },
        ],
        idCardValidity: [
          { required: true, validator: validateIdCardValidity, trigger: 'blur' },
        ],
        legalContactAddr: [
          { required: true, validator: validateAddress, trigger: 'blur' },
        ],
        idCardFrontUrl: [
          { required: true, message: '请上传身份证人像面照片', trigger: 'change' },
        ],
        idCardBackUrl: [
          { required: true, message: '请上传身份证国徽面照片', trigger: 'change' },
        ],
        // 账户代表校验
        accountRepName: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        repIdCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' },
        ],
        repIdCardValidity: [
          { required: true, validator: validateIdCardValidity, trigger: 'blur' },
        ],
        // 单位信息必填校验
        adcode: [
          { required: true, message: '请选择所在地区', trigger: 'change' },
        ],
        unitName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' },
        ],
        unitAddr: [
          { required: true, message: '请输入单位地址', trigger: 'blur' },
        ],
        unitType: [
          { required: true, message: '请选择单位类型', trigger: 'change' },
        ],
        legalType: [
          { required: true, message: '请选择法人类型', trigger: 'change' },
        ],
        licenseTerm: [
          { required: true, message: '请选择执照期限', trigger: 'change' },
        ],
        industry: [
          { required: true, message: '请选择所属行业', trigger: 'change' },
        ],
        businessLicenseUrl: [
          { required: true, message: '请上传营业执照', trigger: 'change' },
        ],
        companyIntro: [{ required: false }],
      },
      // 业务类型选项
      businessTypes: [
        { value: 'recycleStation', label: '回收网点' },
        { value: 'transferStation', label: '中转站' },
        { value: 'sortingCenter', label: '分拣中心' },
        { value: 'wasteEnterprise', label: '利废企业' },
        { value: 'dismantlingCenter', label: '二手交易市场' },
        { value: 'industrialPark', label: '产业园区/集散市场' },
        { value: 'other', label: '其他' },
      ],
      // 行业类型选项
      Industry: [
        { value: 'steel', label: '钢铁' },
        { value: 'nonferrousMetals', label: '有色金属' },
        { value: 'plastic', label: '塑料' },
        { value: 'electronicAppliances', label: '电子电器' },
        { value: 'glass', label: '玻璃' },
        { value: 'tire', label: '轮胎' },
        { value: 'buildingMaterials', label: '建材' },
        { value: 'petrochemical', label: '石油化工' },
        { value: 'electricPower', label: '电力' },
        { value: 'regenerativeResources', label: '再生资源' },
        { value: 'environmentalProtection', label: '环保' },
        { value: 'agriculture', label: '农业' },
        { value: 'service', label: '服务业' },
        { value: 'other', label: '其他' },
      ],
      locationOptions:[],
      idCardFileList:[],
    };
  },
  created() {
    this.getAreaData()
    // 合并父组件传入的初始值
    this.formData = { ...this.formData, ...this.initFormData };
  },
  methods: {
    // 获取行政区域
    getAreaData() {
      let code = 510000,
          recursion = 1;
      getAreaTreeData(code, recursion).then((res) => {
        this.locationOptions = res.data;
      });
    },
    // 营业执照上传回调
    handleLicenseUpload(fileList) {
      this.formData.businessLicenseUrl =
        fileList.length > 0 ? fileList[0].storagePath : '';
      this.$refs.infoForm.validateField('businessLicenseUrl');
    },
    // 身份证照片上传回调
    handleIdCardUpload(fileList) {
      this.idCardFileList = fileList;
      this.formData.idCardFrontUrl = fileList.length > 0 ? fileList[0].storagePath : '';
      this.formData.idCardBackUrl = fileList.length > 1 ? fileList[1].storagePath : '';
      this.$refs.infoForm.validateField('idCardFrontUrl');
      this.$refs.infoForm.validateField('idCardBackUrl');
    },
    // 表单提交
    handleSubmit() {
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          // 提交逻辑，通知父组件
          console.log(this.formData,'this.formDatathis.formData')
          const formObj = {
            ...this.formData,
            adcode: Array.isArray(this.formData.adcode) && this.formData.adcode.length > 0
              ? this.formData.adcode[this.formData.adcode.length - 1]
              : this.formData.adcode
          }
          this.$emit('submit', formObj);
        } else {
          this.$message.error('请完善必填项并确保格式正确！');
          return false;
        }
      });
    },
    handleCancel() {
      this.$emit('cancel', true);
    },
    // 重置表单
    resetForm() {
      this.$refs.infoForm.resetFields();
      this.formData = {
        // 单位信息
        unitName: '',     // 单位名称
        unitAddr: '',     // 单位地址
        unitType: '',                     // 单位类型
        legalType: '',             // 法人类型，natural：自然人，enterprise：企业
        licenseTerm: '',                  // 营业执照期限
        adcode: '',                     // 所在省份
        industry: '',                     // 所属行业
        businessLicenseUrl: '',              // 营业执照图片
        // 法人信息
        legalName: '',                    // 法人姓名
        legalPhone: '',                   // 法人手机号码
        legalEmail: '',                   // 法人电子邮箱
        legalIdCard: '',                  // 法人身份证号
        idCardValidity: '',               // 身份证有效期
        legalContactAddr: '',             // 法人联系地址
        idCardFrontUrl: '',               // 身份证正面URL
        idCardBackUrl: '',                // 身份证国徽URL
        // 账户代表
        accountRepName: '',               // 账户代表姓名
        repIdCard: '',                    // 账户代表身份证号
        repIdCardValidity: '',            // 账户代表身份证有效期
        // 企业简介
        companyIntro: '',                 // 企业简介
      };
    },
  },
};
</script>

<style lang="less" scoped>
/* 核心：子组件居中容器 */
.info-fill-container {
  width: 100%;
  min-height: calc(100vh - 40px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 0;
  background-color: #f5f7fa;
  box-sizing: border-box;
}

/* 表单卡片 */
.info-fill-page {
  width: 100%;
  max-width: 1200px;
  min-width: 900px;
  padding: 30px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}

/* 页面标题 */
.page-header {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}
.page-header h2 {
  margin: 0;
  font-size: 18px;
  color: #1f2937;
  font-weight: 600;
}
.page-header .tag {
  margin-left: 15px;
  color: #666666;
  font-size: 14px;
}

/* 表单分区样式 */
.form-section {
  margin-bottom: 30px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

/* 严格一行两列布局 */
.form-row {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 -12px;
}
.form-col {
  padding: 0 12px;
  box-sizing: border-box;
}
/* 左列固定12格，右列固定12格 */
.form-col:nth-child(1) {
  width: 50%;
}
.form-col:nth-child(2) {
  width: 50%;
}

/* 表单项样式 */
.info-form .el-form-item {
  margin-bottom: 20px;
  width: 100%;
}
.info-form .el-input,
.info-form .el-select {
  width: 100%;
}

/* 上传组件样式 */
.upload-btn {
  width: 100%;
}
.upload-btn .el-upload--picture-card {
  width: 100%;
  height: 120px;
  line-height: 120px;
}

/* 空项占位（保证两列对齐） */
.empty-item {
  margin-bottom: 0 !important;
}
.empty-placeholder {
  width: 100%;
  height: 40px;
  background: transparent;
}

/* 提交按钮 */
.submit-btn {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 0;
}

/* 响应式适配（小屏仍保持两列，缩小间距） */
@media (max-width: 1024px) {
  .info-fill-page {
    min-width: auto;
    width: 95%;
    padding: 20px;
  }
  .form-row {
    margin: 0 -8px;
  }
  .form-col {
    padding: 0 8px;
  }
}
.addTitle{
  position: relative;
}
.title {
  position: absolute;
  bottom: -55px;
  left: 0%;
  color: orangered;
}
/* 移动端强制单列（特殊场景） */
@media (max-width: 768px) {
  .info-fill-page {
    min-width: auto;
    width: 100%;
    max-width: 100%;
    padding: 16px;
    .page-header .h2 { 
      font-size: 14px !important;
    }
    .tag {
      font-size: 14px !important;
    }
  }
  .info-fill-container {
    width: 100% !important;
  }
  .section-title {
    font-size: 14px !important;
  }
  /deep/.el-upload{
    .el-upload-dragger {
      width: 200px !important;
      .uploadBoxs {
        width: 100% !important;
      }
    }
  } 

  /deep/.custom-upload-component-wapper {
    .file-info {
      width: 150px !important;
      height: 150px !important;
      .image-preview {
        width: 150px !important;
        height: 150px !important;
        .preview-image {
          width: 150px !important;
          height: 150px !important;
        }
      }
    }
  }
  
  .form-row {
    flex-wrap: wrap;
  }
  .form-col {
    width: 100% !important;
    margin-bottom: 15px;
  }
  .empty-item {
    display: none;
  }
}
</style>
